/**
 * Deterministic "stock remaining" per cart line. We don't track real stock —
 * this is a pressure signal. The number is a hash of the item key seeded with
 * the local day so it feels static within a browsing session but decreases
 * day-by-day across the week. Range: 7-29 units. Never below 7.
 */
const hash = (s) => {
  let h = 2166136261;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return Math.abs(h);
};

export function stockLeft(itemKey) {
  const day = new Date().toISOString().slice(0, 10); // yyyy-mm-dd
  const seed = hash(`${itemKey}|${day}`);
  // 7..29 range
  return 7 + (seed % 23);
}
